<ng-template #pageOperationsModal>
    <div class="page-modal-section client-operation-modal">
        <div class="page-modal-heading-section">
            <span>{{ page_operation_type }} Advisor Details</span>
            <span class="page-modal-close-icon" (click)="closeAdvisorOperationModal()">&times;</span>
        </div>
        <div class="progress-section">
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 0 }">1</div>
                <p class="each-step-label">Personal & Contact Info</p>
            </div>
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 1 }">2</div>
                <p class="each-step-label">Qualification Info</p>
            </div>
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 2 }">3</div>
                <p class="each-step-label">Current Employment Info</p>
            </div>
            <div class="each-progress-step-section">
                <div class="each-progress-step" [ngClass]="{'each-progress-step-selected': page_operation_stepper > 3 }">4</div>
                <p class="each-step-label">Experience</p>
            </div>
        </div>
        <div class="page-modal-content-section">

            <ng-container *ngIf="page_operation_stepper == 1">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Personal Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Advisor ID *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.advisor_id" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.advisor_id">Advisor ID is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">First Name *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.first_name" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.first_name">First Name is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Last Name *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.last_name" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.last_name">Last Name is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Mobile Number {{APP_CONSTANTS.PHONE_NUMBER_FORMAT}}</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.phone_number" maxlength="{{APP_CONSTANTS.PHONE_NUMBER_LENGTH}}" appFormatPhoneNumber />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.phone_number">Mobile Number is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Email *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.email" [disabled]="page_operation_type != 'Add'" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.email">Email should be valid.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Gender</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.gender_id">
                            <mat-option [value]="''">Select Gender</mat-option>
                            <mat-option *ngFor="let gender of genders_list" [value]="gender.id">{{ gender.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.gender_id">Gender is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Date of Birth *</p>
                        <input
                            type="text"
                            class="page-modal-input"
                            bsDatepicker
                            [maxDate]="current_date"
                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                             placement="right"
                            [(ngModel)]="page_data.date_of_birth"
                        />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.date_of_birth">Date of Birth is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Status *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.advisor_status_id">
                            <mat-option [value]="''">Select Status</mat-option>
                            <mat-option *ngFor="let status of advisor_status_list" [value]="status.id">{{ status.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.advisor_status_id">Status is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Primary Address Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1 *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code *</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.zip_code">ZIP Code is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Address 2 Information (Optional)</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_2_state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_2_region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_2_zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_2_zip_code">ZIP Code is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Address 3 Information (Optional)</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 1</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_line_1" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_line_1">Address Line 1 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Address Line 2</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_line_2" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_line_2">Address Line 2 is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">City</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_city" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_city">City is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">State</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_3_state_id">
                            <mat-option [value]="''">Select State</mat-option>
                            <mat-option *ngFor="let state of states_list" [value]="state.id">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_state_id">State is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Region</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.address_3_region_id">
                            <mat-option [value]="''">Select Region</mat-option>
                            <mat-option *ngFor="let region of region_list" [value]="region.id">{{ region.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_region_id">Region is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">ZIP Code</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.address_3_zip_code" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.address_3_zip_code">ZIP Code is Required.</p>
                    </div>
                </div>
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Social Networking Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Linkedin</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.linkedin_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.linkedin_url">Linkedin is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Twitter</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.twitter_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.twitter_url">Twitter is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Facebook</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.facebook_url" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.facebook_url">Facebook is Required.</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="page_operation_stepper == 2">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Qualification Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Total Experience</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.total_experience" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.total_experience">Total Experience is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">States Registered in *</p>
                        <mat-select multiple class="page-modal-input" [(ngModel)]="page_data.states_registered">
                            <mat-option *ngFor="let state of states_list" [value]="state.code">{{ state.name }} ({{state.code}})</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.states_registered">States Registered is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Number of Licenses</p>
                        <mat-select multiple class="page-modal-input" [(ngModel)]="page_data.total_licenses">
                            <mat-option *ngFor="let license of licenses_list" [value]="license.id">{{ license.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.total_licenses">Number of Licenses is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Number of Certificates *</p>
                        <mat-select multiple class="page-modal-input" [(ngModel)]="page_data.certificates">
                            <mat-option *ngFor="let certificate of certificates_list" [value]="certificate.id">{{ certificate.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.certificates">Number of Certificates is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Professional Associations *</p>
                        <mat-select multiple class="page-modal-input" [(ngModel)]="page_data.professional_associations">
                            <mat-option *ngFor="let professional_association of professional_associations_list" [value]="professional_association.id">{{ professional_association.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.professional_associations">Professional Associations is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Advisor Type</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.advisor_type_id">
                            <mat-option [value]="''">Select Advisor Type</mat-option>
                            <mat-option *ngFor="let advisor_type of advisor_type_list" [value]="advisor_type.id">{{ advisor_type.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.advisor_type_id">Advisor Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Dually Licensed</p>
                        <mat-radio-group [(ngModel)]="page_data.dually_licensed">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.dually_licensed">Dually Licensed is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Dually Registered</p>
                        <mat-radio-group [(ngModel)]="page_data.dually_registered">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.dually_registered">Dually Registered is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Regulatory Disclosures</p>
                        <mat-radio-group [(ngModel)]="page_data.regulatory_disclosures">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.dually_registered">Regulatory Disclosures is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Sells Insurance Products</p>
                        <mat-radio-group [(ngModel)]="page_data.sells_insurance_products">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.dually_registered">Sells Insurance Products is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Sells Retirement Products</p>
                        <mat-radio-group [(ngModel)]="page_data.sells_retirement_products">
                            <mat-radio-button [value]="true">Yes</mat-radio-button>
                            <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.dually_registered">Sells Retirement Products is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Year became Representative</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.date_became_representative_year">
                            <mat-option [value]="''">Select Year became Representative</mat-option>
                            <mat-option *ngFor="let year of represent_years" [value]="year">{{ year }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.date_became_representative_year">Year became Representative is Required.</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="page_operation_stepper == 3">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Current Employment Information</span>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Employment ID</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.employment_id" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.employment_id">Employment ID is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Employment Type</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.employment_type_id">
                            <mat-option [value]="''">Select Employment Type</mat-option>
                            <mat-option *ngFor="let employment_type of employment_type_list" [value]="employment_type.id">{{ employment_type.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.employment_type_id">Employment Type is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Company Name</p>
                        <input type="text" class="page-modal-input" [(ngModel)]="page_data.financial_institution.institution_name" [disabled]="true" />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.financial_institution.institution_name">Company Name is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Company Branch *</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.financial_institution_branch">
                            <mat-option [value]="''">Select Company Branch</mat-option>
                            <mat-option *ngFor="let branch of page_data.financial_institution.branches" [value]="branch.id">{{ branch.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.financial_institution_branch">Company Branch is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Designation</p>
                        <mat-select class="page-modal-input" [(ngModel)]="page_data.designation_id">
                            <mat-option [value]="''">Select Designation</mat-option>
                            <mat-option *ngFor="let designation of designation_list" [value]="designation.id">{{ designation.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.designation_id">Designation is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Date of Joining *</p>
                        <input
                            type="text"
                            class="page-modal-input"
                            bsDatepicker
                            [maxDate]="current_date"
                            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                             placement="left"
                            [(ngModel)]="page_data.date_of_joining"
                        />
                        <p class="page-modal-input-error" *ngIf="page_data_errors.date_of_joining">Date of Joining is Required.</p>
                    </div>
                    <div class="page-modal-input-section client-modal-input-section">
                        <p class="page-modal-input-label">Product Experience</p>
                        <mat-select multiple class="page-modal-input" [(ngModel)]="page_data.product_experience">
                            <mat-option *ngFor="let product of product_group_list" [value]="product.id">{{ product.name }}</mat-option>
                        </mat-select>
                        <p class="page-modal-input-error" *ngIf="page_data_errors.product_experience">Product Experience is Required.</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="page_operation_stepper == 4">
                <div class="each-form-section">
                    <div class="each-form-heading-section">
                        <span>Experience</span>
                    </div>
                    <table class="page-inner-table">
                        <thead>
                            <tr>
                                <th>Actions</th>
                                <th>Employment ID</th>
                                <th>Company Name</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Work Years</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let advisor_experience of page_data.employment_details; let index = index;">
                                <tr *ngIf="advisor_experience_operation_index != index">
                                    <td>
                                        <img src="assets/edit-client.png" class="page-table-actions" (click)="advisorExperienceOperations(advisor_experience, 'Edit', index)" />
                                        <img src="assets/delete-icon.png" class="page-table-actions" (click)="deleteAdvisorExpeience(advisor_experience, index)" />
                                    </td>
                                    <td>{{advisor_experience.prior_employment_id}}</td>
                                    <td>{{advisor_experience.company_name}}</td>
                                    <td>{{advisor_experience.start_date | date: "d-MM-YYYY" }}</td>
                                    <td>{{advisor_experience.end_date | date: "d-MM-YYYY"}}</td>
                                    <td>{{advisor_experience.work_years }} Years</td>
                                </tr>
                                <tr *ngIf="advisor_experience_operation_index == index">
                                    <ng-container *ngTemplateOutlet="advisorExperienceOperationSection;"></ng-container>
                                </tr>
                            </ng-container>
                            <ng-container>
                                <tr *ngIf="advisor_experience_operation_type ==  '' && advisor_experience_operation_index == null">
                                    <td colspan="6">
                                        <span class="page-table-actions" (click)="advisorExperienceOperations(advisor_experience_details, 'Add', null)">+ Add New Experience</span>
                                    </td>
                                </tr>
                                <tr *ngIf="advisor_experience_operation_type ==  'Add' && advisor_experience_operation_index == null">
                                    <ng-container *ngTemplateOutlet="advisorExperienceOperationSection;"></ng-container>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="navigateBack()" *ngIf="page_operation_stepper > 1">Back</button>
            <button class="page-modal-primary-button" (click)="validateAdvisorDetails()" *ngIf="page_operation_stepper < 4">Continue</button>
            <button class="page-modal-primary-button" (click)="validateAdvisorDetails()" *ngIf="page_operation_stepper == 4">Save</button>
            <span class="page-modal-input-error" *ngIf="global_error">Please fill the mandatory fields</span>

        </div>
    </div>
</ng-template>


<ng-template #advisorExperienceOperationSection>
    <td>
        <img src="assets/activity-save.png" class="page-table-actions" (click)="saveAdvisorExperience()" />
        <img src="assets/activity-cancel.png" class="page-table-actions" (click)="cancelAdvisorExperience()" />
    </td>
    <td>
        <input type="text" class="page-inner-table-input" [(ngModel)]="advisor_experience_details.prior_employment_id" [ngClass]="{'page-inner-table-input-error': advisor_experience_details_errors.prior_employment_id}"/>
    </td>
    <td>
        <input type="text" class="page-inner-table-input" [(ngModel)]="advisor_experience_details.company_name" [ngClass]="{'page-inner-table-input-error': advisor_experience_details_errors.company_name}"/>
    </td>
    <td>
        <input
            type="text"
            class="page-inner-table-input"
            bsDatepicker
            [maxDate]="current_date"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
             placement="left"
            [(ngModel)]="advisor_experience_details.start_date"
            [ngClass]="{'page-inner-table-input-error': advisor_experience_details_errors.start_date}"
        />
    </td>
    <td>
        <input
            type="text"
            class="page-inner-table-input"
            bsDatepicker
            [maxDate]="current_date"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
             placement="left"
            [(ngModel)]="advisor_experience_details.end_date"
            [ngClass]="{'page-inner-table-input-error': advisor_experience_details_errors.end_date}"
        />
    </td>
    <td>
        <input type="text" class="page-inner-table-input" [(ngModel)]="advisor_experience_details.work_years" (keypress)="numberOnly($event)" [ngClass]="{'page-inner-table-input-error': advisor_experience_details_errors.work_years}"/>
    </td>
</ng-template>

<ng-template #deleteAdvisorExperienceModal>
    <div class="page-modal-section">
        <div class="page-modal-heading-section">
            <span>Delete Advisor Experience Details</span>
            <span class="page-modal-close-icon" (click)="closeAdvisorExpeienceGoal()">&times;</span>
        </div>
        <div class="page-modal-content-section">
            <p class="page-modal-delete-description">Are you sure you want to delete this Advisor Experience?</p>
        </div>
        <div class="page-modal-footer-section">
            <button class="page-modal-secondary-button" (click)="closeAdvisorExpeienceGoal()">No</button>
            <button class="page-modal-primary-button" (click)="deleteAdvisorExpeienceDetails()">Yes</button>
          </div>
    </div>
</ng-template>
